export default (vueApp) => {
  vueApp.$API.on('token:errored', () => {
    vueApp.logout();
  });
};
